const data = [
  {
    id: 1,
    name: "Agra",
    country: "India",
    region: "North",
    emoji: "🕌",
    moodTags: ["Relaxing", "Spiritual"],
    purposeTags: ["Family outing", "Weekend escape"],
    themeTags: ["Historical Place", "Family-friendly", "Budget Travel"],
    info: "Agra is world-famous for the Taj Mahal, a symbol of eternal love and one of the Seven Wonders of the World. Beyond the Taj, you’ll find the grand Agra Fort, the exquisite Itmad-ud-Daulah’s Tomb, and bustling local bazaars. Don’t miss Mughlai delicacies like kebabs and petha (sweet).",
    image: "https://cdn.thecodehelp.in/Agra.jpeg",
    price: 35758,
    duration: "3 Days",
    mapUrl: "https://www.google.com/maps?q=Agra,India&output=embed",
  },
  {
    id: 2,
    name: "Jaipur",
    country: "India",
    region: "North",
    emoji: "🏰",
    moodTags: ["Cultural", "Relaxing"],
    purposeTags: ["Family outing", "Weekend escape"],
    themeTags: ["Historical Place", "Family-friendly"],
    info: "Jaipur, the 'Pink City,' is a vibrant blend of old and new. Explore majestic forts like Amer and Nahargarh, marvel at the intricate Hawa Mahal, and wander through the bustling lanes of Johari Bazaar. The city's rich culture, royal heritage, and delicious Rajasthani cuisine make it a must-visit.",
    image: "https://cdn.thecodehelp.in/Jaipur.jpeg",
    price: 82560,
    duration: "4 Days",
    mapUrl: "https://www.google.com/maps?q=Jaipur,India&output=embed",
  },
  {
    id: 3,
    name: "Goa",
    country: "India",
    region: "West",
    emoji: "🏖️",
    moodTags: ["Party", "Relaxing"],
    purposeTags: ["Weekend escape", "Solo detox"],
    themeTags: ["Adventure Trip", "Solo Travel", "Budget Travel"],
    info: "Goa is India’s ultimate beach destination, known for its golden sands, vibrant nightlife, and Portuguese charm. Relax on beaches like Baga and Palolem, explore old churches in Old Goa, enjoy thrilling water sports, or just soak up the laid-back vibe. From seafood to beach shacks, Goa is pure holiday magic.",
    image: "https://cdn.thecodehelp.in/Goa.jpeg",
    price: 29695,
    duration: "5 Days",
    mapUrl: "https://www.google.com/maps?q=Goa,India&output=embed",
  },
  {
    id: 4,
    name: "Varanasi",
    country: "India",
    region: "North",
    emoji: "🕉️",
    moodTags: ["Spiritual", "Cultural"],
    purposeTags: ["Solo detox", "Spiritual journey"],
    themeTags: ["Spiritual Trip", "Solo Travel"],
    info: "Varanasi, one of the world’s oldest living cities, sits on the sacred River Ganges. Known for its ghats, evening Ganga Aarti, and narrow lanes filled with temples, it’s a place of deep spirituality. A sunrise boat ride on the Ganges and tasting Banarasi street food are unforgettable experiences.",
    image: "https://cdn.thecodehelp.in/Varanasi.jpeg",
    price: 31095,
    duration: "3 Days",
    mapUrl: "https://www.google.com/maps?q=Varanasi,India&output=embed",
  },
  {
    id: 5,
    name: "Darjeeling",
    country: "India",
    region: "East",
    emoji: "🏞️",
    moodTags: ["Relaxing", "Nature"],
    purposeTags: ["Nature walk", "Weekend escape"],
    themeTags: ["Adventure Trip", "Family-friendly"],
    info: "Nestled in the Himalayas, Darjeeling is famous for its lush tea plantations and stunning views of Kanchenjunga. Ride the historic Darjeeling Himalayan Railway (Toy Train), visit Tiger Hill for a breathtaking sunrise, and explore colonial-era architecture. It's the perfect escape for nature lovers.",
    image: "https://cdn.thecodehelp.in/Darjeeling.jpeg",
    price: 78595,
    duration: "6 Days",
    mapUrl: "https://www.google.com/maps?q=Darjeeling,India&output=embed",
  },
  {
    id: 6,
    name: "Jaisalmer",
    country: "India",
    region: "North",
    emoji: "🏜️",
    moodTags: ["Adventurous", "Cultural"],
    purposeTags: ["Nature walk", "Family outing"],
    themeTags: ["Adventure Trip", "Historical Place"],
    info: "Known as the 'Golden City,' Jaisalmer rises from the Thar Desert like a mirage. Its magnificent fort, ancient havelis, and vast sand dunes create a magical atmosphere. Experience a desert safari on camelback, watch a traditional puppet show, and sleep under the stars in a desert camp.",
    image: "https://cdn.thecodehelp.in/Jaisalmer.jpeg",
    price: 68595,
    duration: "4 Days",
    mapUrl: "https://www.google.com/maps?q=Jaisalmer,India&output=embed",
  },
  {
    id: 7,
    name: "Udaipur",
    country: "India",
    region: "North",
    emoji: "🏞️",
    moodTags: ["Romantic", "Relaxing"],
    purposeTags: ["Family outing", "Weekend escape"],
    themeTags: ["Historical Place", "Family-friendly"],
    info: "Often called the 'Venice of the East,' Udaipur is a city of shimmering lakes and royal palaces. Take a boat ride on Lake Pichola, explore the majestic City Palace, and admire the intricate architecture of Jagdish Temple. Its romantic ambiance makes it a favorite for couples and families.",
    image: "https://upload.wikimedia.org/wikipedia/commons/c/c0/Udaipur_5.jpg",
    price: 22000,
    duration: "3 Days",
    mapUrl: "https://www.google.com/maps?q=Udaipur,India&output=embed",
  },
  {
    id: 8,
    name: "Rishikesh",
    country: "India",
    region: "North",
    emoji: "🧘",
    moodTags: ["Spiritual", "Adventurous"],
    purposeTags: ["Solo detox", "Spiritual journey"],
    themeTags: ["Spiritual Trip", "Adventure Trip", "Solo Travel"],
    info: "Known as the 'Yoga Capital of the World,' Rishikesh is a spiritual hub nestled in the foothills of the Himalayas. It's a place for meditation, yoga retreats, and thrilling adventures like white-water rafting. Walk across the iconic Laxman Jhula and Ram Jhula bridges and feel the serene vibes.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/8/8c/Rishikesh_India_%28183707211%29.jpeg",
    price: 10000,
    duration: "4 Days",
    mapUrl: "https://www.google.com/maps?q=Rishikesh,India&output=embed",
  },
  {
    id: 9,
    name: "Khajuraho",
    country: "India",
    region: "North",
    emoji: "🛕",
    moodTags: ["Cultural", "Romantic"],
    purposeTags: ["Spiritual journey", "Couple trip"],
    themeTags: ["Historical Place", "Spiritual Trip"],
    info: "Khajuraho is renowned for its stunning temples adorned with intricate and erotic sculptures, a testament to India's rich artistic heritage. A UNESCO World Heritage site, these temples showcase a unique blend of Hindu and Jain architecture, offering a glimpse into medieval life and beliefs.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/b/b6/Khajuraho_Dulhadeo_2010.jpg",
    price: 16500,
    duration: "2 Days",
    mapUrl: "https://www.google.com/maps?q=Khajuraho,India&output=embed",
  },
  {
    id: 10,
    name: "Munnar",
    country: "India",
    region: "South",
    emoji: "🍃",
    moodTags: ["Relaxing", "Nature"],
    purposeTags: ["Nature walk", "Solo detox"],
    themeTags: ["Adventure Trip", "Solo Travel"],
    info: "Munnar is a breathtaking hill station in Kerala, famous for its rolling hills covered in emerald-green tea plantations. The air is fresh, the scenery is spectacular, and the atmosphere is tranquil. Visit a tea factory, hike to Anamudi Peak, or simply relax and enjoy the serene landscape.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/6/6d/Munnar_-_View_from_Grand_Plaza_Hotel.jpg",
    price: 18500,
    duration: "4 Days",
    mapUrl: "https://www.google.com/maps?q=Munnar,India&output=embed",
  },
  {
    id: 11,
    name: "Amritsar",
    country: "India",
    region: "North",
    emoji: "🕍",
    moodTags: ["Spiritual", "Cultural"],
    purposeTags: ["Family outing", "Spiritual journey"],
    themeTags: ["Spiritual Trip", "Historical Place", "Educational Tour"],
    info: "Amritsar is home to the magnificent Golden Temple, the holiest shrine of Sikhism, where thousands of pilgrims gather daily. The city is also known for the historic Jallianwala Bagh and the energetic Wagah Border ceremony. Don't leave without tasting the delicious Amritsari kulcha.",
    image:
      "https://d2rdhxfof4qmbb.cloudfront.net/wp-content/uploads/20200819131211/iStock-535570117-scaled.jpg",
    price: 14000,
    duration: "2 Days",
    mapUrl: "https://www.google.com/maps?q=Amritsar,India&output=embed",
  },
  {
    id: 12,
    name: "Hampi",
    country: "India",
    region: "South",
    emoji: "🏛️",
    moodTags: ["Adventurous", "Cultural"],
    purposeTags: ["Solo detox", "History tour"],
    themeTags: ["Historical Place", "Solo Travel", "Educational Tour"],
    info: "Hampi, a UNESCO World Heritage site, is a captivating landscape of ancient ruins, giant boulders, and historic temples. Once the capital of the Vijayanagara Empire, it's now a backpacker's paradise. Explore the Virupaksha Temple, ride a coracle boat on the Tungabhadra River, and climb Matanga Hill for a stunning sunset.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/f2/Hampi%2C_India%2C_Stone_ornaments_at_Vijaya_Vitthala_Temple.jpg",
    price: 17000,
    duration: "3 Days",
    mapUrl: "https://www.google.com/maps?q=Hampi,India&output=embed",
  },
  {
    id: 13,
    name: "Paris",
    country: "Global",
    region: "Europe",
    emoji: "🗼",
    moodTags: ["Romantic", "Cultural"],
    purposeTags: ["Couple trip", "City break"],
    themeTags: ["Historical Place", "Art & Culture"],
    info: "Paris, France's capital, is a major European city and a global center for art, fashion, gastronomy and culture.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRB818pssV1oe8nFKCJQRqCn9zAlKXfgXVs6Jn4Wmf-Irl6sz_p3Mb0xIYpGOnDgwOQNkc",
    price: 120000,
    duration: "5 Days",
    mapUrl: "https://www.google.com/maps?q=Paris,France&output=embed",
  },
  {
    id: 14,
    name: "Kyoto",
    country: "Global",
    region: "Asia",
    emoji: "⛩️",
    moodTags: ["Spiritual", "Cultural", "Nature"],
    purposeTags: ["Spiritual journey", "Nature walk"],
    themeTags: ["Historical Place", "Solo Travel"],
    info: "Kyoto, once the capital of Japan, is a city on the island of Honshu. It's famous for its numerous classical Buddhist temples, as well as gardens, imperial palaces, Shinto shrines and traditional wood houses.",
    image:
      "https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    price: 95000,
    duration: "7 Days",
    mapUrl: "https://www.google.com/maps?q=Kyoto,Japan&output=embed",
  },
  {
  id: 15,
  name: "New York City",
  country: "Global",
  region: "North America",
  emoji: "🗽",
  moodTags: ["Vibrant", "Modern", "Cultural"],
  purposeTags: ["City break", "Shopping", "Nightlife"],
  themeTags: ["Skyscrapers", "Art & Culture"],
  info: "New York City, USA, is a global hub for culture, fashion, and finance, known for Times Square, Central Park, and Broadway.",
  image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=1170&q=80",
  price: 150000,
  duration: "6 Days",
  mapUrl: "https://www.google.com/maps?q=New+York+City,USA&output=embed",
},
{
  id: 16,
  name: "London",
  country: "Global",
  region: "Europe",
  emoji: "🎡",
  moodTags: ["Royal", "Historical", "Modern"],
  purposeTags: ["Family trip", "City exploration"],
  themeTags: ["Historical Place", "Museums"],
  info: "London, England’s capital, is famed for Big Ben, Buckingham Palace, Tower Bridge, and the London Eye.",
  image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1170&q=80",
  price: 130000,
  duration: "5 Days",
  mapUrl: "https://www.google.com/maps?q=London,UK&output=embed",
},
{
  id: 17,
  name: "Dubai",
  country: "Global",
  region: "Middle East",
  emoji: "🏙️",
  moodTags: ["Luxury", "Modern", "Adventure"],
  purposeTags: ["Shopping", "Desert safari", "Luxury stay"],
  themeTags: ["Skyscrapers", "Adventure"],
  info: "Dubai, UAE, is known for luxury shopping, ultramodern architecture like Burj Khalifa, and vibrant nightlife.",
  image: "https://images.unsplash.com/photo-1546412414-8035e1776c9a?auto=format&fit=crop&w=1170&q=80",
  price: 110000,
  duration: "4 Days",
  mapUrl: "https://www.google.com/maps?q=Dubai,UAE&output=embed",
},
{
  id: 18,
  name: "Rome",
  country: "Global",
  region: "Europe",
  emoji: "🏛️",
  moodTags: ["Romantic", "Historical", "Cultural"],
  purposeTags: ["Couple trip", "Heritage tour"],
  themeTags: ["Historical Place", "Art & Culture"],
  info: "Rome, Italy’s capital, is famed for ancient ruins like the Colosseum and Roman Forum, as well as Vatican City.",
  image: "https://static.toiimg.com/photo/msid-53891769,width-96,height-65.cms",
  price: 125000,
  duration: "6 Days",
  mapUrl: "https://www.google.com/maps?q=Rome,Italy&output=embed",
},
{
  id: 19,
  name: "Bangkok",
  country: "Global",
  region: "Asia",
  emoji: "🏮",
  moodTags: ["Vibrant", "Nightlife", "Cultural"],
  purposeTags: ["Backpacking", "Shopping", "Food tour"],
  themeTags: ["Temples", "Street Food"],
  info: "Bangkok, Thailand’s capital, is a bustling city known for ornate shrines, vibrant street life, and floating markets.",
  image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?auto=format&fit=crop&w=1170&q=80",
  price: 80000,
  duration: "5 Days",
  mapUrl: "https://www.google.com/maps?q=Bangkok,Thailand&output=embed",
},
{
  id: 20,
  name: "Bali",
  country: "Global",
  region: "Asia",
  emoji: "🌴",
  moodTags: ["Relaxing", "Tropical", "Spiritual"],
  purposeTags: ["Beach holiday", "Yoga retreat", "Honeymoon"],
  themeTags: ["Beaches", "Nature"],
  info: "Bali, Indonesia, is a tropical paradise with beaches, coral reefs, forested volcanic mountains, and yoga retreats.",
  image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1170&q=80",
  price: 90000,
  duration: "7 Days",
  mapUrl: "https://www.google.com/maps?q=Bali,Indonesia&output=embed",
},
{
  id: 21,
  name: "Santorini",
  country: "Global",
  region: "Europe",
  emoji: "🏖️",
  moodTags: ["Romantic", "Relaxing", "Scenic"],
  purposeTags: ["Honeymoon", "Couple trip"],
  themeTags: ["Beaches", "Island escape"],
  info: "Santorini, Greece, is famous for its whitewashed houses, blue-domed churches, volcanic beaches, and breathtaking sunsets.",
  image: "https://travel.usnews.com/dims4/USNEWS/e836fc5/2147483647/resize/976x652%5E%3E/crop/976x652/quality/85/format/webp/?url=https%3A%2F%2Ftravel.usnews.com%2Fimages%2FGettyImages-462922955.jpg",
  price: 100000,
  duration: "5 Days",
  mapUrl: "https://www.google.com/maps?q=Santorini,Greece&output=embed",
},
{
  id: 22,
  name: "Istanbul",
  country: "Global",
  region: "Europe/Asia",
  emoji: "🕌",
  moodTags: ["Cultural", "Historical", "Spiritual"],
  purposeTags: ["Cultural trip", "City break"],
  themeTags: ["Historical Place", "Food"],
  info: "Istanbul, Turkey, bridges Europe and Asia, famous for Hagia Sophia, Blue Mosque, and Grand Bazaar.",
  image: "https://img.freepik.com/free-photo/shot-scenic-city-view-taken-from-top-tower-istanbul-city_181624-61059.jpg",
  price: 95000,
  duration: "6 Days",
  mapUrl: "https://www.google.com/maps?q=Istanbul,Turkey&output=embed",
},
{
  id: 23,
  name: "Sydney",
  country: "Global",
  region: "Australia",
  emoji: "🌊",
  moodTags: ["Adventure", "Relaxing", "Modern"],
  purposeTags: ["Beach holiday", "City break"],
  themeTags: ["Beaches", "Skyscrapers"],
  info: "Sydney, Australia, is famous for its Opera House, Harbour Bridge, Bondi Beach, and vibrant lifestyle.",
  image: "https://img.freepik.com/premium-photo/bridge-with-sunset-background_1301236-80011.jpg",
  price: 160000,
  duration: "7 Days",
  mapUrl: "https://www.google.com/maps?q=Sydney,Australia&output=embed",
},
{
  id: 24,
  name: "Cairo",
  country: "Global",
  region: "Africa",
  emoji: "🕌",
  moodTags: ["Historical", "Adventure", "Cultural"],
  purposeTags: ["Heritage tour", "Cultural trip"],
  themeTags: ["Historical Place", "Adventure"],
  info: "Cairo, Egypt’s capital, is famous for the Great Pyramids of Giza, Sphinx, and the Nile River.",
  image: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Cairo_Skyline.jpg",
  price: 105000,
  duration: "5 Days",
  mapUrl: "https://www.google.com/maps?q=Cairo,Egypt&output=embed",
},

];

export default data;
